import React from 'react';

export function TypeSvg() {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.30469 0C2.09887 0 0.304688 1.79491 0.304688 4V12C0.304688 14.2051 2.09887 16 4.30469 16C6.51051 16 8.30469 14.2051 8.30469 12V4C8.30469 1.79491 6.51051 0 4.30469 0ZM4.30469 1.45455C5.70832 1.45455 6.85014 2.59636 6.85014 4V7.27273H1.75923V4C1.75923 2.59636 2.90105 1.45455 4.30469 1.45455ZM14.4865 6.54545C11.88 6.54545 9.75923 8.66618 9.75923 11.2727C9.75923 13.8793 11.88 16 14.4865 16C17.0931 16 19.2138 13.8793 19.2138 11.2727C19.2138 8.66618 17.0931 6.54545 14.4865 6.54545ZM14.4865 8C16.2909 8 17.7592 9.46836 17.7592 11.2727C17.7592 11.9117 17.5687 12.5041 17.2507 13.0085L12.7507 8.50852C13.2551 8.19051 13.8475 8 14.4865 8ZM1.75923 8.72727H6.85014V12C6.85014 13.4036 5.70832 14.5455 4.30469 14.5455C2.90105 14.5455 1.75923 13.4036 1.75923 12V8.72727ZM11.7223 9.53693L16.2223 14.0369C15.7179 14.3549 15.1255 14.5455 14.4865 14.5455C12.6821 14.5455 11.2138 13.0771 11.2138 11.2727C11.2138 10.6337 11.4043 10.0414 11.7223 9.53693Z"
        fill="black"
      />
    </svg>
  );
}
